import { render } from "./AgentsTableNameCell.vue?vue&type=template&id=4d930770&scoped=true&ts=true"
import script from "./AgentsTableNameCell.vue?vue&type=script&lang=ts"
export * from "./AgentsTableNameCell.vue?vue&type=script&lang=ts"

import "./AgentsTableNameCell.vue?vue&type=style&index=0&id=4d930770&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d930770"]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QChip,QTooltip});
